import React from "react";
import { PropTypes } from "prop-types";
import { MrbPage, MrbPageHeader } from "mrb/components/layout";
import { MrbTabLayout, MrbTabContent } from "mrb/components/tabs";
import { defaultTemplate } from "common/hoc";
import { AppReleaseVersions, BetaChannel } from "administration/app-release/components";

function AppReleaseCenterTemplate({ appReleaseCenterViewStore, t }) {
    const { title, tabsStore, appReleaseViewStore, betaChannelViewStore } = appReleaseCenterViewStore;

    return (
        <MrbPage store={appReleaseCenterViewStore} t={t}>
            <MrbPageHeader>
                <div className="c-page__header--top">
                    <div>{t(title)}</div>
                </div>
            </MrbPageHeader>
            <MrbTabLayout store={tabsStore} t={t}>
                <MrbTabContent label={t("ADMINISTRATION.APP_RELEASE.TABS.VERSIONS")}>
                    <AppReleaseVersions appReleaseViewStore={appReleaseViewStore} t={t} />
                </MrbTabContent>
                <MrbTabContent label={t("ADMINISTRATION.APP_RELEASE.TABS.BETA_CHANNEL")}>
                    <BetaChannel betaChannelViewStore={betaChannelViewStore} t={t} />
                </MrbTabContent>
            </MrbTabLayout>
        </MrbPage>
    );
}

AppReleaseCenterTemplate.propTypes = {
    appReleaseCenterViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default defaultTemplate(AppReleaseCenterTemplate);
